import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import themeManager from '../../utils/themeManager';

const ThemeToggle = () => {
  const [theme, setTheme] = useState(themeManager.getCurrentTheme());

  useEffect(() => {
    // Inicijalizuj sa trenutnom temom iz themeManager
    setTheme(themeManager.getCurrentTheme());
    
    // Slusaj promene teme
    const handleThemeChange = (event) => {
      setTheme(event.detail.theme);
    };
    
    window.addEventListener('themeChanged', handleThemeChange);
    
    return () => {
      window.removeEventListener('themeChanged', handleThemeChange);
    };
  }, []);

  const toggleTheme = () => {
    const newTheme = themeManager.toggleTheme();
    setTheme(newTheme);
  };

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-lg bg-card border border-border hover:bg-accent transition-all duration-300 spring-animation"
      aria-label={`Prebaci na ${theme === 'light' ? 'tamnu' : 'svetlu'} temu`}
    >
      <div className="relative w-6 h-6">
        <Icon
          name={theme === 'light' ? 'Sun' : 'Moon'}
          size={24}
          className={`absolute inset-0 transition-all duration-300 ${
            theme === 'light' 
              ? 'text-accent rotate-0 scale-100 opacity-100' 
              : 'text-accent rotate-90 scale-0 opacity-0'
          }`}
        />
        <Icon
          name={theme === 'dark' ? 'Moon' : 'Sun'}
          size={24}
          className={`absolute inset-0 transition-all duration-300 ${
            theme === 'dark' 
              ? 'text-accent rotate-0 scale-100 opacity-100' 
              : 'text-accent rotate-90 scale-0 opacity-0'
          }`}
        />
      </div>
    </button>
  );
};

export default ThemeToggle;